import { PROJECT_SERVICE } from "@/services/consts";

export const PROJECT_CATEGORY_API = (tenantId: string) =>
  `${PROJECT_SERVICE}tenant/${tenantId}/project-categories`;
